import ical from 'ical-generator';
import { format, parseISO } from 'date-fns';

interface SermonSchedule {
  id: string;
  title: string;
  date: string;
  scripture: string | null;
  notes: string | null;
  series?: {
    title: string;
  };
  sermon_id: string | null;
}

export function downloadICS(schedules: SermonSchedule[]) {
  const calendar = ical({
    name: 'Sermon Schedule',
    timezone: 'UTC',
    prodId: {
      company: 'SermonBuild',
      product: 'Sermon Schedule',
      language: 'EN'
    }
  });

  schedules.forEach(schedule => {
    const eventDate = new Date(schedule.date);
    calendar.createEvent({
      start: eventDate,
      allDay: true,
      summary: schedule.title,
      description: `Scripture: ${schedule.scripture || 'TBD'}\n\nNotes: ${schedule.notes || ''}`,
      location: schedule.series?.title ? `Series: ${schedule.series.title}` : undefined,
      categories: [{
        name: 'Sermons'
      }],
      status: 'CONFIRMED',
      busystatus: 'BUSY'
    });
  });

  const blob = new Blob([calendar.toString()], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `sermon-schedule-${format(new Date(), 'yyyy-MM-dd')}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function generateGoogleCalendarURL(schedule: SermonSchedule) {
  const eventDate = parseISO(schedule.date);
  const nextDay = new Date(eventDate);
  nextDay.setDate(nextDay.getDate() + 1);

  const event = {
    text: schedule.title,
    dates: `${format(eventDate, 'yyyyMMdd')}/${format(nextDay, 'yyyyMMdd')}`,
    details: `Scripture: ${schedule.scripture || 'TBD'}\n\nNotes: ${schedule.notes || ''}`,
    location: schedule.series?.title ? `Series: ${schedule.series.title}` : '',
  };

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.text,
    dates: event.dates,
    details: event.details,
    location: event.location,
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function generateOutlookURL(schedule: SermonSchedule) {
  const eventDate = parseISO(schedule.date);
  const nextDay = new Date(eventDate);
  nextDay.setDate(nextDay.getDate() + 1);

  const event = {
    subject: schedule.title,
    startdt: format(eventDate, "yyyy-MM-dd'T'00:00:00"),
    enddt: format(nextDay, "yyyy-MM-dd'T'00:00:00"),
    body: `Scripture: ${schedule.scripture || 'TBD'}\n\nNotes: ${schedule.notes || ''}`,
    location: schedule.series?.title ? `Series: ${schedule.series.title}` : '',
  };

  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: event.subject,
    startdt: event.startdt,
    enddt: event.enddt,
    body: event.body,
    location: event.location,
    allday: 'true'
  });

  return `https://outlook.office.com/calendar/0/deeplink/compose?${params.toString()}`;
}

export function generateCalendarFeedURL(userId: string) {
  // Use the Supabase Edge Function URL directly
  return `https://qoxdevzrzqcqbtdehgwn.functions.supabase.co/calendar-feed?userId=${userId}`;
}